import React from 'react';
import { Box, Typography, Card, CardHeader, CardContent, Chip } from '@mui/material';

/**
 * Displays topic-wise question breakdown with performance indicators
 * @param {Array} questionBreakdown - question_breakdown array from question_analysis
 */
const QuestionBreakdownCards = ({ questionBreakdown }) => {
  if (!questionBreakdown || questionBreakdown.length === 0) return null;

  const getPerformanceColor = (performance) => {
    // Unified color scheme - white/gray for all performance levels
    return { primary: 'rgba(255, 255, 255, 0.9)' };
  };

  return (
    <Box sx={{ mb: 2 }}>
      <Typography
        variant="h6"
        sx={{
          color: 'rgba(255,255,255,0.95)',
          fontWeight: 600,
          mb: 2,
          fontSize: '1.05rem',
          letterSpacing: '0.04em',
          textTransform: 'uppercase',
        }}
      >
        Question Breakdown Details
      </Typography>

      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: { xs: '1fr', md: 'repeat(2, 1fr)', lg: 'repeat(3, 1fr)' },
          gap: 2,
        }}
      >
        {questionBreakdown.map((item, index) => {
          return (
            <Card
              key={index}
              sx={{
                backgroundColor: 'rgba(12, 14, 22, 0.82)',
                borderRadius: '20px',
                border: '1px solid rgba(255, 255, 255, 0.1)',
                boxShadow: '0 14px 36px rgba(0, 0, 0, 0.35)',
                backdropFilter: 'blur(14px)',
                transition: 'all 0.25s ease',
                '&:hover': {
                  transform: 'translateY(-2px)',
                  boxShadow: '0 16px 40px rgba(0, 0, 0, 0.45)',
                },
              }}
            >
              <CardHeader
                title={
                  <Typography variant="subtitle1" sx={{ fontWeight: 600, color: 'rgba(255,255,255,0.95)', fontSize: '0.95rem', letterSpacing: '0.02em' }}>
                    {item.topic}
                  </Typography>
                }
                action={
                  <Chip
                    label={item.performance}
                    size="small"
                    sx={{
                      bgcolor: 'rgba(255, 255, 255, 0.08)',
                      color: 'rgba(255, 255, 255, 0.85)',
                      fontWeight: 600,
                      fontSize: '0.65rem',
                      height: 22,
                      border: '1px solid rgba(255,255,255,0.12)',
                      letterSpacing: '0.03em',
                      textTransform: 'uppercase',
                    }}
                  />
                }
                sx={{ pb: 1, pt: 2, px: 2.5 }}
              />
              <CardContent sx={{ pt: 0, px: 2.5, pb: 2 }}>
                <Typography
                  variant="body2"
                  sx={{
                    color: 'rgba(255,255,255,0.75)',
                    lineHeight: 1.6,
                    fontSize: '0.8rem',
                  }}
                >
                  {item.key_insights}
                </Typography>
              </CardContent>
            </Card>
          );
        })}
      </Box>
    </Box>
  );
};

export default QuestionBreakdownCards;
